define("Modules/PageFooter", [`Module`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`Geolocation`, `Locale`],
		defaults: {
			mode: `legacy`, // legacy | ux3
			render: true,
			show: true,
			showSiteLinks: true,
			showSocialLinks: {
				desktop: true,
				mobile: true,
			},
			showAbout: {
				desktop: true,
				mobile: true,
			},
			showCreators: {
				desktop: true,
				mobile: true,
			},
			showBlog: {
				desktop: true,
				mobile: true,
			},
			showDiscover: {
				desktop: true,
				mobile: true,
			},
			showSupport: {
				desktop: true,
				mobile: true,
			},
			showPrivacy: {
				desktop: true,
				mobile: true,
			},
			showPrivacyChoices: {
				desktop: false,
				mobile: false,
			},
			showManageCookies: {
				desktop: true,
				mobile: true,
			},
			showTerms: {
				desktop: true,
				mobile: true,
			},
			showCookiePolicy: {
				desktop: true,
				mobile: true,
			},
			showDoNotSellMyInfo: {
				desktop: false,
				mobile: false,
			},
			showCareers: {
				desktop: true,
				mobile: true,
			},
			transition: `fade`,
		},
		async prepare(setup) {
			const { Geolocation, data } = this;
			const {
				mode,
				showAbout,
				showBlog,
				showDiscover,
				showCookiePolicy,
				showCreators,
				showManageCookies,
				showPrivacy,
				showSiteLinks,
				showSocialLinks,
				showSupport,
				showTerms,
				showCareers,
			} = setup;

			let { showPrivacyChoices, showDoNotSellMyInfo } = setup;

			const geo = await Geolocation.get();

			if (geo && geo.in_us) {
				showPrivacyChoices.desktop = true;
				showPrivacyChoices.mobile = true;
				showDoNotSellMyInfo.desktop = true;
				showDoNotSellMyInfo.mobile = true;
			}

			this.assign(data, {
				mode,
				showAbout,
				showBlog,
				showDiscover,
				showCookiePolicy,
				showCreators,
				showDoNotSellMyInfo,
				showManageCookies,
				showPrivacy,
				showPrivacyChoices,
				showSiteLinks,
				showSocialLinks,
				showSupport,
				showTerms,
				showCareers,
				legalLinks: this.Locale.getLegalLinks(),
			});
		},
		constructor(setup) {
			const { container, data, Locale } = this;
			const { mode } = data;

			container.setAttribute(`mode`, mode);
			this.addClass(`hide-ios`);
			this.addClass(`hide-android`);

			Locale.get({
				fireImmediately: true,
				subscribe: (locale) => {
					const { available, selected } = locale;
					const legalLinks = Locale.getLegalLinks();
					const existingLegalLinks = data.legalLinks || {};
					const legalLinksChanged =
						!this.isEqual(existingLegalLinks.privacyPolicyUrl, legalLinks.privacyPolicyUrl) ||
						!this.isEqual(existingLegalLinks.termsOfUseUrl, legalLinks.termsOfUseUrl) ||
						!this.isEqual(existingLegalLinks.termsAndConditionsUrl, legalLinks.termsAndConditionsUrl);

					if (legalLinksChanged) {
						data.legalLinks = legalLinks;
						this.render();
					}

					const localeElement = this.get(`.choose-language-text`);

					if (this.isObject(localeElement)) {
						localeElement.innerHTML = `${selected.uniqueLabel}`;

						if (available.length < 2) {
							this.hide({ selector: `[action="choose-language"]` });
						}
					}
				},
			});

			// TODO: Determine if mobile app links should only displayed on associated devices
		},
		listeners: [
			{
				event: `click`,
				filter: `[action]`,
				handler({ currentTarget }) {
					const action = currentTarget.getAttribute(`action`);

					switch (action) {
						case `manage-cookies`:
							this.App.loadOverlay({
								type: `ManageCookies`,
								setup: {
									backgroundOpacity: 0.6,
								},
							});
							break;

						case `choose-language`:
							this.Locale.loadLanguageSelectionOverlay();
							break;
					}
				},
			},
		],
	});
});

define("Modules/PageFooter.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/PageFooter/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " <div class=\"app-store hide-mobile\"> <p class=\"prompt\">Get the Tixr App</p> <div class=\"app-store-links\"> <a href=\"//apps.apple.com/us/app/tixr-event-tickets/id843423849\" target=\"_blank\" rel=\"noopener noreferrer\" name=\"apple-store-button\" class=\"app-button button ux4\" style=\"background-image:url('/static/images/apple-store-download_en_US.svg')\"  aria-label=\"Download on the App Store\" > </a> <a href=\"//play.google.com/store/apps/details?id=com.tixr.tixr&pli=1\" target=\"_blank\" rel=\"noopener noreferrer\" name=\"google-play-button\" class=\"app-button button ux4\" style=\"background-image:url('/static/images/google-play-store-download_en_US.svg')\"  aria-label=\"Get it on Google Play\" > </a> </div> </div> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <nav class=\"right\" aria-label=\"Footer links\"> <div class=\"company-column\"> <h2>Company</h2> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showCreators") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1098},"end":{"line":1,"column":1178}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showAbout") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1179},"end":{"line":1,"column":1250}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showBlog") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1251},"end":{"line":1,"column":1310}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showDiscover") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1311},"end":{"line":1,"column":1364}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSupport") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1365},"end":{"line":1,"column":1440}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showCareers") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1441},"end":{"line":1,"column":1509}}})) != null ? stack1 : "")
    + " </div> <div class=\"legal-column\"> <h2>Legal</h2> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showCookiePolicy") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1559},"end":{"line":1,"column":1692}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showManageCookies") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1693},"end":{"line":1,"column":1781}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showPrivacy") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1782},"end":{"line":1,"column":1912}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showPrivacyChoices") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1913},"end":{"line":1,"column":2010}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showDoNotSellMyInfo") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2011},"end":{"line":1,"column":2117}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"legalLinks") : depth0)) != null ? lookupProperty(stack1,"termsAndConditionsUrl") : stack1),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2118},"end":{"line":1,"column":2280}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showTerms") : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2281},"end":{"line":1,"column":2417}}})) != null ? stack1 : "")
    + " </div> </nav> <hr class=\"divider hide-desktop\" /> ";
},"4":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//creators.tixr.com\">Partner with Tixr</a> ";
},"6":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//creators.tixr.com/about\">About</a> ";
},"8":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//blog.tixr.com\">Blog</a> ";
},"10":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/\">Discover</a> ";
},"12":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//fansupport.tixr.com\">Fan Support</a> ";
},"14":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//careers.tixr.com\">Careers</a> ";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"legalLinks") : depth0)) != null ? lookupProperty(stack1,"cookiePolicyUrl") : stack1), depth0))
    + "\" target=\"_blank\" rel=\"noopener noreferrer\">Cookie Policy</a> ";
},"18":function(container,depth0,helpers,partials,data) {
    return " <a href=\"#\" action=\"manage-cookies\">Manage Cookies</a> ";
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"legalLinks") : depth0)) != null ? lookupProperty(stack1,"privacyPolicyUrl") : stack1), depth0))
    + "\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a> ";
},"22":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/privacy-choices\" target=\"_blank\">Privacy Choices</a> ";
},"24":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/do-not-sell-my-info\" target=\"_blank\">Do Not Sell My Info</a> ";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"legalLinks") : depth0)) != null ? lookupProperty(stack1,"termsAndConditionsUrl") : stack1), depth0))
    + "\" target=\"_blank\" rel=\"noopener noreferrer\">Terms and Conditions</a> ";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"legalLinks") : depth0)) != null ? lookupProperty(stack1,"termsOfUseUrl") : stack1), depth0))
    + "\" target=\"_blank\" rel=\"noopener noreferrer\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"legalLinks") : depth0)) != null ? lookupProperty(stack1,"termsLabel") : stack1), depth0))
    + "</a> ";
},"30":function(container,depth0,helpers,partials,data) {
    return " hide-desktop";
},"32":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"social-links\"> <a href=\"//www.x.com/tixr_\" aria-label=\"tixr x\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"x",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3518},"end":{"line":1,"column":3533}}}))
    + "</a> <a href=\"//www.instagram.com/tixrhq\" aria-label=\"tixr instagram\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"instagram",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3603},"end":{"line":1,"column":3626}}}))
    + "</a> <a href=\"//www.facebook.com/tixrhq\" aria-label=\"tixr facebook\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"facebook",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3694},"end":{"line":1,"column":3716}}}))
    + "</a> </div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"parallax\"> <hr class=\"divider wide\" /> <div class=\"top-content\"> <div class=\"left\"> <div class=\"logo\"> <a href=\"/\" aria-label=\"home\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"tixr",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":145},"end":{"line":1,"column":163}}}))
    + "</a> </div> "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSiteLinks") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":175},"end":{"line":1,"column":976}}})) != null ? stack1 : "")
    + " </div> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSiteLinks") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":984},"end":{"line":1,"column":2475}}})) != null ? stack1 : "")
    + "  <div class=\"app-store absolute"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSiteLinks") : depth0),{"name":"unless","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2535},"end":{"line":1,"column":2584}}})) != null ? stack1 : "")
    + "\"> <p class=\"prompt\">Get the Tixr App</p> <div class=\"app-store-links\"> <a href=\"//apps.apple.com/us/app/tixr-event-tickets/id843423849\" target=\"_blank\" rel=\"noopener noreferrer\" name=\"apple-store-button\" class=\"app-button button ux4\" style=\"background-image:url('/static/images/apple-store-download_en_US.svg')\"  aria-label=\"Download on the App Store\" > </a> <a href=\"//play.google.com/store/apps/details?id=com.tixr.tixr&pli=1\" target=\"_blank\" rel=\"noopener noreferrer\" name=\"google-play-button\" class=\"app-button button ux4\" style=\"background-image:url('/static/images/google-play-store-download_en_US.svg')\"  aria-label=\"Get it on Google Play\" > </a> </div> </div> </div> <hr class=\"divider\" /> <div class=\"bottom-content\"> <nav class=\"left\" aria-label=\"Social links\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSocialLinks") : depth0),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":3419},"end":{"line":1,"column":3735}}})) != null ? stack1 : "")
    + " </nav> <div class=\"right\"> <a href=\"#\" action=\"choose-language\" aria-label=\"choose a language\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"earth",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3831},"end":{"line":1,"column":3850}}}))
    + " <span class=\"choose-language-text\" translate=\"no\"></span></a> </div> </div> </div>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=PageFooter.js.map